export default "__VITE_ASSET__CKJ$JdqZ__"